import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectSite = _resolveComponent("SelectSite")!

  return (_openBlock(), _createBlock(_component_SelectSite, {
    selectedSite: _ctx.selectedSite,
    title: _ctx.title,
    "site-list-namespace": _ctx.siteListNamespace,
    "regle-cle": _ctx.regleCle,
    class: "step-one-container",
    onPick: _ctx.pick,
    onFilterChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pick(undefined)))
  }, null, 8, ["selectedSite", "title", "site-list-namespace", "regle-cle", "onPick"]))
}